import { render } from "./MILESTONE_COMPLETED.vue?vue&type=template&id=6a4b5d6f&scoped=true&ts=true"
import script from "./MILESTONE_COMPLETED.vue?vue&type=script&lang=ts"
export * from "./MILESTONE_COMPLETED.vue?vue&type=script&lang=ts"

import "./MILESTONE_COMPLETED.vue?vue&type=style&index=0&id=6a4b5d6f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a4b5d6f"]])

export default __exports__